// extracted by mini-css-extract-plugin
module.exports = {"container":"terms_container__t117s","header":"terms_header__Qkml0","content":"terms_content__cuJOs"};